import { personInfoFrag } from '../../../../../../utils/type/person.common-type';

export const getWorksFrag = `
    id
    dateFrom
    dateTo
    folderId
    serviceId
    person {
        ${personInfoFrag}
    }
    workData {
        ... on WorkDataSanctionObject {
            data
        }
    }
`;
